import ConfigManager from '@/config/ConfigManager.js';
import Account from '@/helper/AccountHelper.js';
import Locale from "@/helper/locale/Locale.js";

export function WebInterfaceController(campaign) {
    this.urlInterface = campaign.website;
    this.returnPage = '';

    this.openInterface = function () {
        let isShowHeader = 'false';
        let theme = ConfigManager.getAppName();
        let appName = ConfigManager.getAppName();
        let suffledToken = Account.getTokenShuffle();
        let historyCount = this.getHistoryCount();
        let returnUrl = window.location.href + '?back=' + historyCount;
        let localeCode = Locale.getLocaleCode();

        if(this.returnPage){
            returnUrl = window.location.origin + '/' + this.returnPage;
        }

        let url = this.urlInterface
            + '&token=' + suffledToken
            + '&locale=' + localeCode
            + '&header=' + isShowHeader
            + '&theme=' + theme
            + '&appName=' + appName
            + '&return_url=' + encodeURIComponent(returnUrl);

        if(campaign.interfaceDisplay == 'surveyapprove' || campaign.interfaceDisplay == 'survey'){
            url += '&success_survey_url=' + encodeURIComponent(window.location.origin + '/' + this.returnPage);
        }

        // support history truemoney
        if (this.isTrueMoney()) {
            url += '&history_url=' + encodeURIComponent(window.location.origin + '/history');
        }

        if (historyCount == 0) {
            window.location.replace(url);
        } else {
            window.location = url;
        }
    };

    this.openHistoryInterface = function () {

    };

    this.getHistoryCount = function() {
        if (this.isStarbuck()) {
            return -2;
        } else if (this.isTopup()) {
            return -3;
        } else {
            return 0;
        }
    };

    this.isTrueMoney = function () {
        if (this.urlInterface.indexOf('wondd/truemoney') == -1 && this.urlInterface.indexOf('truemoney') >= 0) {
            return true;
        }
        return false;
    };

    this.isStarbuck = function () {
        return (this.urlInterface.indexOf('starbucks') >= 0);
    };

    this.isTopup = function () {
        return (this.urlInterface.indexOf('/Topup/InterfaceLanding') >= 0)
    };

    this.setPage = function(page) {
        this.returnPage = page;
    }
}
